<template>
  <!-- 登录页面 -->
  <div class="login">
    <div class="login-wrap">
      <div class="login-mask"></div>
      <!-- 设置宽高  以免二维码出现滚动条 -->
      <div class="login-block" style=" min-width: 400px;min-height: 550px;max-width: 520px;">
        <div class="loginone"></div>
        <div class="logintwo" style=" min-width: 400px;min-height: 550px;" v-show="twoShow">
          <div class="code" @click="codeswitch"></div>
          <div class="login-title">
            <span @click="phoneShow" :style="{
              color: listswitch ? '#000000' : '#b2b2b2'
            }">密码登录</span>
            <el-divider direction="vertical"></el-divider>
            <span @click="codeShow" :style="{
              color: listphoto ? '#000000' : '#b2b2b2'
            }">验证码登录</span>
          </div>
          <!-- 账号登录 -->
          <AccountLogin v-if="listswitch" @transfer="transfer()" @fun="fun()"></AccountLogin>

          <!-- 验证码登录 -->
          <CodeLogin v-if="listphoto" @transfer="transfer()"> </CodeLogin>
        </div>
        <!-- 扫码登录+绑定手机号 -->
        <ScanCode v-if="scanswitch" :msg='msg' @codefun="codefun()" @loginto="loginto()" @transfer="transfer()">
        </ScanCode>
        <!-- 注册 -->
        <RegisterLogin v-if="regisShow" @loginto="loginto()"></RegisterLogin>

        <!-- 找回密码 -->
        <RetrieveLogin v-if="retrieveShow" @previous="previous()"></RetrieveLogin>

      </div>
    </div>
    <div></div>
  </div>
</template>
<script>
import sliderVerifyCode from "@/components/slider-verify-code.vue";
import CodeLogin from "@/components/codeLogin";
import AccountLogin from "@/components/accountLogin";
import RegisterLogin from "@/components/registerLogin";
import RetrieveLogin from "@/components/retrieveLogin";
import ScanCode from "@/components/scanCode";

export default {
  components: { sliderVerifyCode, CodeLogin, AccountLogin, RegisterLogin, RetrieveLogin, ScanCode },

  name: "login",

  data() {
    //const count = 60;  倒计时的时间
    const checkStatus = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请拖动滑块完成验证"));
      } else {
        if (
          this.form.name == "" ||
          this.form.pass == "" ||
          !this.form.name ||
          !this.form.pass
        ) {
          setTimeout(() => {
            this.form.isLock = false;
            this.$refs.form.validateField("name");
            this.$refs.form.validateField("pass");
            return callback(new Error("验证未通过"));
          }, 1);
        }
        callback();
      }
    };
    // 手机号码验证
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("手机号不能为空！"));
      }
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确！"));

      }
      callback();
    };
    return {
      showPwd: false,
      name: "",
      form: {},
      pwd: "",
      isLock: [{ validator: checkStatus, trigger: "blur" }],
      rules: {
        control: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        receiveNo: [{ validator: validatePhone, trigger: "blur" }],
      },
      ruleForm: {
        receiveNo: "",
        control: "",
      },
      listswitch: true,
      count_show: true,
      listphoto: false,
      twoShow: true,
      regisShow: false,
      loginShow: false,
      scanswitch: false,
      retrieveShow: false,
      msg: false,
      userInfo: {},
      count: 1,
      checked: true,
    };
  },
  created() {
    if (this.$route.query.date) {
      // this.twoShow = true;
      this.twoShow = false;
      this.listswitch = false;
      this.scanswitch = true;
    }
    // console.log(this.$route.query);
    if (this.$route.query.prog) {
      this.twoShow = false;
      this.listswitch = false;
      this.scanswitch = true;
      this.msg = this.$route.query.prog;
    }


  },
  methods: {
    handlerLock(data) {
      if (data) {
        this.$refs.form.validateField("isLock");
      }
    },
    phoneShow() {
      this.listswitch = true;
      this.listphoto = false;
    },
    codeShow() {
      this.listswitch = false;
      this.listphoto = true;
    },
    getCode() {
      this.count = 60; //倒计时时间
      this.count_show = false; //控制倒计时显示隐藏
      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count--;
        } else {
          clearInterval(this.timer);
          this.count_show = true;
        }
      }, 1000);
    },
    register() {
      let that = this;
      // that.loginShow = true;regisShow
      that.twoShow = false;
      that.retrieveShow = false
      that.regisShow = false;
    },
    loginto() {
      let that = this;
      that.twoShow = true;
      that.regisShow = false;
      that.retrieveShow = false;
      that.scanswitch = false;
    },
    previous() {
      let that = this;
      that.twoShow = true;
      that.regisShow = false;
      that.retrieveShow = false;
    },
    transfer(abb) {
      console.log(abb)
      this.regisShow = true;
      this.retrieveShow = false
      this.twoShow = false;
      this.listswitch = true;
      this.scanswitch = false;
      this.listphoto = false;
    },
    fun() {
      let that = this;

      that.retrieveShow = true;
      that.twoShow = false;
      that.regisShow = false;
      console.log(this.retrieveShow)
    },
    codeswitch() {
      let that = this;
      that.twoShow = false;
      that.scanswitch = true;

    },
    codefun() {
      let that = this;
      that.twoShow = true;
      that.scanswitch = false;
    }

  },
};
</script>
<style lang="scss" scoped>
.login-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background-color: rgba(1, 1, 1, 0.2);
  background: url(./../imgs/loginBg.jpg) no-repeat center;
  background-size: 100% 100%;
  z-index: 1;
}

.login-block {

  background-color: #ffffff;
  position: fixed;
  top: 50%;
  left: 70%;
  transform: translate(-50%, -50%);
  z-index: 2;
  border-radius: 10px;
  display: -webkit-box;
  // padding: 26px 50px 50px 50px;
}

.loginone {
  display: none;
  // padding: 0px;
  // height: 100%;
  // width: 400px;
  // background: url(../imgs/sea.png) no-repeat;
  // background-size: 100% 100%;
}

.logintwo {
  position: relative;
  padding: 0px;
  // height: 100%;
  font-size: 18px;
  min-width: 400px;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  margin: 0 auto;
  // border: 1px solid #ccc;
}

// .code {
//   position: absolute;
//   left: 400px;
//   width: 0;
//   height: 0;
//   border-style: solid;
//   border-width: 50px 50px 50px;
//   border-color: #d9534f #d9534f transparent transparent;

//   background-image: url(../imgs/logincode.png);
// }
.code {
  position: absolute;
  right: 0;
  top: 0;
  width: 80px;
  height: 80px;
  background-image: url(../imgs/logincode.png);
  background-size: 100% 100%;
  border-top-right-radius: 10px;

  &:after {
    display: block;
    content: "";
    width: 0;
    height: 0;
    border: 40px solid #fff;
    border-right-color: transparent;
    border-top-color: transparent;
    border-top-right-radius: 10px;
  }
}

.loginaccount {
  // padding: 50px;
}

.logina {
  // padding: 0 50px;
}

.login-title {
  font-size: 18px;
  // font-weight: bold;
  padding: 0 50px 30px;
  color: #b2b2b2;
  margin-top: 20px;
  cursor: pointer;
}

.login-titles {
  padding: 0 50px 0px;
  color: #b2b2b2;
  margin-top: 20px;
}

.codeShow:visited {
  text-decoration: none;
}

.login-row {
  /* margin-top: 78px; */
 width: 100%;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 18px;
  margin-top: 48px;
}

.login-row input {
  font-size: 18px;
  outline: none;
  border: none;
  flex: 1;
  height: 22px;
}

.login-row .eye-icon {
  width: 24px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
}

.forget {
  font-size: 14px;
  float: right;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #999999;
}

.login-bttn {
  width: 400px;
  height: 56px;
  background-color: #db3a3b !important;
  margin-top: 60px;
  display: flex;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;
}

.login-btn {
  width: 400px;
  height: 56px;
  background-color: #db3a3b !important;
  margin-top: 160px;
  display: flex;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #ffffff !important;
  cursor: pointer;

  &:hover {
    background-color: #db3a3b !important;
    color: #ffffff !important;
  }
}

.login-btn.disabled {
  background-color: #db3a3b;
  cursor: not-allowed;
}

.login-logon {
  font-size: 14px;
  margin: 10px 130px;
}

.acea-row {
  display: flex;
  flex-wrap: wrap;
}

.acea-row.row-bottom {
  align-items: flex-end;
}

.acea-row.row-between {
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/login/login.vue